import React, { useState, useEffect, createContext } from "react";
import AuthUser from "../services/AuthUser";

export const ServicesContext = createContext();

export const ServicesProvider = ({ children }) => {
    const [services, setServices] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { http } = AuthUser();

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await http.get("/services");
                setServices(response.data);
            } catch (err) {
                setError("Failed to load services." );
            } finally {
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

 console.log(services);

    return (
        <ServicesContext.Provider value={{ services, loading, error }}>
            {children}
        </ServicesContext.Provider>
    );
};
